import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useBoundStore } from "useStore";
import useDebounce from "hooks/useDebounce";
import { useState, useEffect } from "react";

export default function SearchBar() {
  const searchTaller = useBoundStore((state) => state.soTallerSearch);
  const setSearch = useBoundStore((state) => state.setSoTallerSearch);
  const [searchField, setSearchField] = useState("");
  const debouncedSearchField = useDebounce(searchField, 500);
  const search = searchTaller?.searchTerm;
  useEffect(() => {
    setSearchField(search || "");
  }, [search]);

  useEffect(() => {
    setSearch((prev) => ({ ...prev, searchTerm: debouncedSearchField }));
  }, [debouncedSearchField, setSearch]);

  return (
    <TextField
      id="taller-search-field"
      label="Buscar"
      placeholder="Nº ticket, SKU..."
      variant="outlined"
      value={searchField || ""}
      onChange={(e) => setSearchField(e.target.value)}
      InputProps={{
        startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1 }} />,
      }}
      sx={{
        width: 300,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "8px",
        },
        "& .MuiInputBase-input": {
          backgroundColor: "#fff !important",
          borderRadius: "8px",
          WebkitBoxShadow: "0 0 0 1000px white inset",
        },
        "& .MuiOutlinedInput-notchedOutline": { borderRadius: "5px" },
      }}
    />
  );
}
